import { z } from 'zod';

export const createDeliverableTypeSchema = z.object({
  label: z.string().trim().min(1, 'Name is required').max(150),
});
